/**
 * @generated SignedSource<<ad1eb2cdf9e4b7e6eff3941bf4f7f91c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SellerApplicationWrapper_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SellerApplicationBenefits_viewer" | "SellerApplicationForm_viewer">;
  readonly " $fragmentType": "SellerApplicationWrapper_viewer";
};
export type SellerApplicationWrapper_viewer$key = {
  readonly " $data"?: SellerApplicationWrapper_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SellerApplicationWrapper_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "leadId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SellerApplicationWrapper_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SellerApplicationBenefits_viewer"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "leadId",
          "variableName": "leadId"
        }
      ],
      "kind": "FragmentSpread",
      "name": "SellerApplicationForm_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "7619659bd0392b6d92a8f3414d631ef4";

export default node;
